export enum REQUEST_STATUS {
  pending = 'pending',
  accepted = 'accepted',
}
